module.exports = __webpack_public_path__ + "static/media/54-poipu.4cb76de3.jpeg";